module.exports = __webpack_public_path__ + "img/บาร์นะเคิล.9e6f3936.jpg";